import React from "react";
import { Tag, Icon, Popover } from "antd";

const ColorByStatus = {
  PROCESSADO: "green",
  ERRO: "red",
  CRIADO: null,
  PROCESSANDO: "blue"
};

export const TableColumns = [
  {
    title: "STATUS",
    dataIndex: "status",
    key: "status",
    render: ([status, erro]) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Tag color={ColorByStatus[status]}>{status}</Tag>
        {erro && (
          <Popover content={erro}>
            <Icon type="info-circle" style={{ color: "red" }} />
          </Popover>
        )}
      </div>
    )
  },
  {
    title: "ARQUIVO",
    dataIndex: "file",
    key: "file"
  },
  {
    title: "DATA CADASTRO",
    dataIndex: "dt_cadastro",
    key: "dt_cadastro"
  },
  {
    title: "DATA PROCESSAMENTO",
    dataIndex: "dt_processamento",
    key: "dt_processamento"
  }
];



// WEBPACK FOOTER //
// ./src/pages/Contratos/UploadContaCorrente/table-columns.js